import { PageFooter } from "PFApp/components/page_footer";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useRollForwardWizardNavigation } from "../../hooks/use_roll_forward_wizard_navigation";
import { useRollForwardWizardStore } from "../../roll_forward_wizard_store";

const ENGAGEMENTS_PATH = "/workflow/engagements";

export const WizardFooter = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });
  const { t: tCommon } = useTranslation("translation");
  const navigate = useNavigate();
  const { isFirstStep, isLastStep, canGoNext, goNext, goPrevious } = useRollForwardWizardNavigation();

  const wizardState = useRollForwardWizardStore((state) => ({
    filters: state.filters,
    sourceTarget: state.sourceTarget,
    continuity: state.continuity
  }));

  const handleCancel = () => navigate(ENGAGEMENTS_PATH);

  // TODO: [SP-11688] replace the console log with the real Create roles submit
  const handleCreateRoles = () => console.log(wizardState);

  return (
    <PageFooter>
      <Button
        kind="secondary"
        text={tCommon("cancel")}
        onClick={handleCancel}
        qaId="RollForwardWizard.Footer.CancelButton"
      />
      <Inline gap="spacingLg">
        <Button
          kind="secondary"
          icon="arrow-left"
          iconPlacement="left"
          text={tCommon("previous")}
          disabled={isFirstStep}
          onClick={goPrevious}
          qaId="RollForwardWizard.Footer.PreviousButton"
        />
        {isLastStep ? (
          <Button
            disabled={!canGoNext}
            text={t("buttons.createRoles")}
            onClick={handleCreateRoles}
            qaId="RollForwardWizard.Footer.CreateRolesButton"
          />
        ) : (
          <Button
            icon="arrow-right"
            iconPlacement="right"
            text={tCommon("next")}
            disabled={!canGoNext}
            onClick={goNext}
            qaId="RollForwardWizard.Footer.NextButton"
          />
        )}
      </Inline>
    </PageFooter>
  );
};
